// extracted by mini-css-extract-plugin
export default {"tableContainer":"history_tableContainer__7W8en","historyContainer":"history_historyContainer__thzOL"};